import React from 'react';

const Header = () => {
   return (
      <header className='ds-flex-center-center'>
         <nav className='navbar navbar-expand-lg bg-body-tertiary'>
            <div className='container'>
               <a className='navbar-brand' href='#'>
                  <img alt='' src='../assets/images/logo.png' height='60' className='logo' alt='Quinn`s Piano Studio Logo'/>
               </a>
               <button className='navbar-toggler' type='button' data-bs-toggle='collapse' data-bs-target='#navbarSupportedContent' aria-controls='navbarSupportedContent' aria-expanded='false' aria-label='Toggle navigation'>
                  <span className='navbar-toggler-icon'></span>
               </button>
               <div className='collapse navbar-collapse' id='navbarSupportedContent'>
                  <ul className='navbar-nav mx-auto mb-2 mb-lg-0'>
                     <li className='nav-item'>
                        <a className='nav-link active' aria-current='page' href='/'>Home</a>
                     </li>
                     <li className='nav-item'>
                        <a className='nav-link' href='#aboutMe'>About Me</a>
                     </li>
                     <li className='nav-item'>
                        <a className='nav-link' href='#testimonials'>Testimonials</a>
                     </li>
                     <li className='nav-item'>
                        <a className='nav-link' href='#contactUs'>Contact Us</a>
                     </li>
                  </ul>
               </div>
            </div>
         </nav>
      </header>
   );
};

export default Header;
